import {defineViewSlotCreator} from "@verdure/core";
// @ts-ignore
import AppAny from './app/any/Index.vue'

export default defineViewSlotCreator({
    app: {
        any: AppAny
    }
})
